import React from 'react';
import styled from 'styled-components';
import RichText, { ContentRenderer } from '../../components/RichText';
import { BodyText, Heading1 } from '../../components/Typography';
import { LinkId } from '../../constants';
import BREAK_POINTS from '../../styling/media-queries';
import { Action, DevicesPageContent } from '../fees-and-deductibles/models';
import DevicesSection from './DevicesSection';
import PageAction, { PageActionProps } from './PageAction';

const s = {
  PageTitle: styled(Heading1)`
    text-align: center;
    margin-top: 20px;

    @media ${BREAK_POINTS.desktop} {
      font-size: 45px;
    }
  `,
  Intro: styled(BodyText)`
    font-size: 18px;
    text-align: center;
    margin-top: 28px;
    margin-bottom: 28px;
  `,
  SectionLogoWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  `,
  SectionLogo: styled.img`
    width: 300px;
    margin-bottom: 15px;
    position: relative;
    margin: 10px 0px 20px 10px;

    @media ${BREAK_POINTS.desktop} {
      width: 450px;
      height: 250px;
    }
  `,
  Hr: styled.hr`
    opacity: 0.2;
  `,
  Content: styled.section`
    text-align: center;
    font-size: 16px;

    img {
      height: 100px;
      width: 100px;
      margin-top: 70x;
      margin-bottom: 15px;
    }

    h1 {
      font-size: 25px;
      font-weight: 500;
    }

    p {
      margin: 1.5em;
      line-height: 28px;
    }
  `,
};

const actionRenderer: ContentRenderer<PageActionProps, Action> = {
  component: PageAction,
  convertProps: ({ fields }) => ({
    ...fields,
    id: fields.type === 'expert' ? LinkId.WhatsCoveredNeedHelpCall : LinkId.WhatsCoveredSeeFees,
  }),
};

const WhatsCoveredPageContent = ({ icon, title, description, sections, content }: DevicesPageContent) => (
  <>
    {icon && (
      <s.SectionLogoWrapper>
        <s.SectionLogo src={icon.fields.file.url} />
      </s.SectionLogoWrapper>
    )}
    <s.PageTitle>{title}</s.PageTitle>
    <s.Intro>
      <RichText content={description} />
    </s.Intro>
    {sections.map((s) => (
      <DevicesSection key={s.sys.id} {...s.fields} />
    ))}
    <s.Hr />
    {content && (
      <s.Content>
        <RichText content={content} blockRenderers={{ action: actionRenderer }} />
      </s.Content>
    )}
  </>
);

export default WhatsCoveredPageContent;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/whats-covered/WhatsCoveredPageContent.tsx